import { Stack, Tooltip, Typography, useTheme } from '@mui/material';
import { FaIcon } from '../../../atoms/icons';

export { parseSortModel } from './parseSortModel';

export const PAGE_SIZE_OPTIONS = [15, 30, 50];
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0];

type CellErrorMessageProps = {
  errorDisplayMessage: React.ReactNode;
  errorTooltipMessage?: React.ReactNode;
};

export function CellErrorMessage({ errorDisplayMessage, errorTooltipMessage }: CellErrorMessageProps) {
  const theme = useTheme();

  const cellDisplay = (
    <Typography sx={{ color: theme.palette.error.dark, cursor: 'default' }} variant="body2">
      <FaIcon name="circle-exclamation" color={theme.palette.error.main} style={{ marginRight: '4px' }} />
      {errorDisplayMessage}
    </Typography>
  );

  return (
    <Stack direction={'column'} spacing={1} sx={{ height: '100%' }} justifyContent="center">
      {errorTooltipMessage ? (
        <Tooltip title={errorTooltipMessage} arrow placement="top">
          {cellDisplay}
        </Tooltip>
      ) : (
        cellDisplay
      )}
    </Stack>
  );
}


